
export default {
  props: {
    label: String,
    content: Array | String
  },

  data () {
    return {
      // envTest: 'http://localhost:3002/api/cockpit/addAssets?token=440011169da7176c513407605ed290',
      fileList: []
    }
  },

  methods: {
    async change (file, fileList) {
      this._content = fileList
      await this.$nextTick()
      await this.$nextDOMUpdate()
      await this.$nextTick()
      await this.$nextDOMUpdate()
      this.$store.commit('layout/setShouldUpdateFrameScrollHeight')
    },
    submit () {
      this.$refs.upload.submit();
    },
    handleRemove (file) {
      this.$refs.upload.uploadFiles.splice(this.$refs.upload.uploadFiles.indexOf(file), 1)
    },
    makeEllipsis (string) {
      return string.length > 33 ? string.slice(0, 33) + '...' : string
    }
  },

  watch: {
    submitCondition () {
      this.submit()
    }
  },

  computed: {
    _content: {
      set (value) {
        this.$emit('update:content', value)
      },

      get () {
        return this.content
      }
    },
    submitCondition () {
      return this.$store.state.form.submitImages
    }
  },

  mounted () {
    if (this.content === undefined) this._content = []
  }
}
